import SiteManagerView from "./SiteManagerView"

var siteManagerView = new SiteManagerView();
window["registerManagerView"](siteManagerView); 